import { useMemo } from 'react';
import { useLocation as useLocationNative } from 'react-router';

import { AppLocation } from './AppLocation';

/**
 * Custom hook that returns an enhanced AppLocation object
 * instead of the default React Router location
 * @returns An AppLocation instance with proper type definitions and additional functionality
 */
export const useLocation = () => {
  const location = useLocationNative();

  return useMemo(() => new AppLocation(location), [location]);
};
